<div class="global-controls-container">

  @if (!isLogsVisible) {
  <div class="global-container-left">
    <!-- Global Control Heading Icon Tooltip and Logs-->
    <div class="global-control-heading">
      <img class="global-control-icon" src="assets/svg/global-control.svg" alt="Global Controls" />
      <div class="lato-18-n-vw title-text">Global Controls</div>
      <div class="global-control-info-icon" [ngbTooltip]="INFO_TOOLTIP" [placement]="'right'"
        cygovSvgIcon [svgName]="'info-board-icon'" tooltipClass="global-control-info-tooltip"></div>
      <div class="logs-heading" (click)="toggleLogsVisibility()" role="button" tabindex="0"
        aria-label="Open global control logs"
        (keydown.enter)="toggleLogsVisibility(); $event.preventDefault()"
        (keydown.space)="toggleLogsVisibility(); $event.preventDefault()">Logs</div>
    </div>

    <!-- Dropdowns Section -->
    <div class="dropdowns-section">
      <!-- Origin Drop Down -->
      <div class="origin-dropdown-container">
        <label class="lato-16-n-vw origin-dropdown-label">Origin</label>
        <cygov-custom-drop-down class="origin-dropdown" [isDropDownOpen]="isOriginDropDownOpen"
          (toggleDropDownEvent)="handleOriginDropdownToggleEvent($event)"
          [cachedItemList]="originSubEntityList" [itemList]="originSubEntityList"
          bindLabel="displayName" [showCheckbox]="false" [openedColor]="'#1D1E29'"
          [opened]="'#121521'" [itemsColor]="'#1D1E29'" [showCross]="false" [showSearch]="true"
          [closed]="'#2E3241'" [singleSelect]="true" (ngModelValueChange)="selectOrigin($event)"
          [widthArea]="'100%'" [searchIconSvgName]="'search-icon'" [selectedColor]="'#c5c9d1'"
          [title]="'Choose Entity'" [preSelectedItems]="getSelectedOriginName()"
          [resetKey]="dropdownResetKey" [isGlobalControl]="true">
        </cygov-custom-drop-down>
      </div>

      <!-- Destination Dropdown -->
      <div class="destination-dropdown-container">
        <label class="lato-16-n-vw destination-dropdown-label">Destination</label>
        <cygov-custom-drop-down class="destination-dropdown" [itemList]="destinationSubEntityList"
          [cachedItemList]="destinationSubEntityList"
          [preSelectedItems]="getSelectedDestinationNames()"
          (toggleDropDownEvent)="handleDestinationDropdownToggleEvent($event)"
          [isDropDownOpen]="isDestinationDropDownOpen" bindLabel="displayName" [showCheckbox]="true"
          [openedColor]="'#1D1E29'" [opened]="'#121521'" [itemsColor]="'#1D1E29'"
          [showCross]="false" [showSearch]="false" [closed]="'#2E3241'" [singleSelect]="false"
          (ngModelValueChange)="selectDestination($event)" [widthArea]="'100%'"
          [searchIconSvgName]="'search-icon'" [selectedColor]="'#c5c9d1'"
          [title]="'Choose Destination'" [resetKey]="dropdownResetKey" [isGlobalControl]="true">
        </cygov-custom-drop-down>
      </div>
    </div>

    <!-- Add Button -->
    <div class="global-controls-add-button-container" [class.disabled]="!isAddActionAllowed">
      <cygov-button [buttonText]="'ADD'" [buttonWidth]="'6.2vw'" [buttonHeight]="'4.5vh'"
        (click)='addButtonClicked()' [fullyDisabled]="!isAddActionAllowed" [textSize]="'18'"
        [boldType]="'n'" [buttonColor]="'#29A9EB'" [hoverColor]="'#0080C3'">
      </cygov-button>
    </div>
  </div>

  <div class="vertical-separator"></div>

  <div class="global-container-right">
    <!-- Top Action Bar -->
    <div class="top-action-bar">
      <!-- Edit Button (normal mode) -->
      @if (!isEditMode) {
      <div class="pencil-icon-wrapper" (click)="toggleEditMode()" role="button" tabindex="0"
        aria-label="Enable global control edit mode"
        (keydown.enter)="toggleEditMode(); $event.preventDefault()"
        (keydown.space)="toggleEditMode(); $event.preventDefault()">
        <div class="pencil-icon" cygovSvgIcon [svgName]="'edit-button'"></div>
      </div>
      } @else {
      <!-- Action Buttons (edit mode) -->
      <div class="action-buttons">
        <div class="cross-icon-wrapper" (click)="toggleEditMode()" role="button" tabindex="0"
          aria-label="Exit global control edit mode"
          (keydown.enter)="toggleEditMode(); $event.preventDefault()"
          (keydown.space)="toggleEditMode(); $event.preventDefault()">
          <div class="cross-icon" cygovSvgIcon [svgName]="'x-icon-type2'"></div>
        </div>
      </div>
      }
    </div>

    <!-- Horizontal Separator -->
    <div class="horizontal-separator"></div>

    <div class="text-box-wrapper" #connectionsList>
      @if (isLoading) {
      @for (row of skeletonRows; track $index) {
      <ng-container *ngTemplateOutlet="globalControlSkeletonRow"></ng-container>
      }
      } @else {
      @if ((allGlobalControlItems && allGlobalControlItems.length > 0) || pendingAddRows.length) {
      @for (item of allGlobalControlItems; track item.id; let i = $index;) {
      @if (isConnectionDeleting(item.id)) {
      <!-- this connection's delete is in flight, so it holds its place until the request returns -->
      <ng-container *ngTemplateOutlet="globalControlSkeletonRow"></ng-container>
      } @else {
      <div class="text-box" [class.edit-mode]="isEditMode">
        <div class="text-content">
          <div class="text-row" [class.invalid]="!item.isConnectionValid">
            <div>
              <span class="label">Origin:</span>
              <span class="value" cygovEllipsisTooltip [tooltipText]="item?.originName"
                [tooltipBackgroundColor]="'#21242f'"
                [tooltipPlacement]="'right'">{{item?.originName}}</span>
            </div>
            <div>
              <span class="label">Destination:</span>
              <span class="value" cygovEllipsisTooltip [tooltipText]="item?.destinationName"
                [tooltipBackgroundColor]="'#21242f'"
                [tooltipPlacement]="'top'">{{item?.destinationName}}</span>
            </div>
            @if (!item.isConnectionValid) {
            <div class="error-icon" [ngbTooltip]="ERROR_TOOLTIP" [placement]="'top'"
              [disableTooltip]="isEditMode" cygovSvgIcon [svgName]="'info-board-icon'"
              tooltipClass="error-tooltip">
            </div>
            }
          </div>
        </div>

        @if (isEditMode) {
        <div class="text-box-cross-icon-wrapper" (click)="showConfirmationDeletion(i)" role="button"
          tabindex="0"
          [attr.aria-label]="'Delete global control ' + (item?.originName || '') + ' to ' + (item?.destinationName || '')"
          (keydown.enter)="showConfirmationDeletion(i); $event.preventDefault()"
          (keydown.space)="showConfirmationDeletion(i); $event.preventDefault()">
          <div class="text-box-cross-icon" cygovSvgIcon [svgName]="'x-icon-type2'"></div>
        </div>
        }
      </div>
      }
      }
      <!-- connections being added have no rows yet, so their placeholders go at the end, which is
           where the created rows are appended -->
      @for (row of pendingAddRows; track $index) {
      <ng-container *ngTemplateOutlet="globalControlSkeletonRow"></ng-container>
      }
      }@else {
      <!-- no connections at all: the shared NO DATA panel, with no search to clear -->
      <div class="no-data-area">
        <cygov-no-data-found [message]="'No Global Controls Available'" [showClear]="false">
        </cygov-no-data-found>
      </div>
      }
      }
    </div>
  </div>
  }
  @else{
  <div class="global-controls-logs-container">
    <cygov-global-controls-logs [currentRootEntity]="this.currentRootEntity"
      (logsDismissed)="toggleLogsVisibility()">
    </cygov-global-controls-logs>
  </div>
  }

</div>

<!-- Placeholder for one global control connection: the real row's own box and grid, with the
     Origin and Destination values shimmering where their text sits. Used for the section's own
     load and for a single row's add or delete. -->
<ng-template #globalControlSkeletonRow>
  <div class="text-box text-box--pending" [class.edit-mode]="isEditMode">
    <div class="text-content">
      <div class="text-row">
        <div>
          <cygov-skeleton width="70%" height="1.6vh"></cygov-skeleton>
        </div>
        <div>
          <cygov-skeleton width="70%" height="1.6vh"></cygov-skeleton>
        </div>
      </div>
    </div>
  </div>
</ng-template>
